// removed by extract-text-webpack-plugin
module.exports = {"status-bar":"styles__status-bar___3ZA8l","status-indication":"styles__status-indication___3xVF-","group-container":"styles__group-container___3uew-","group-filter-container":"styles__group-filter-container___1JuII","filters-container":"styles__filters-container___GCzeR","icon-button":"styles__icon-button___34eNQ","group-tag-value-container":"styles__group-tag-value-container___pmEpq","sample-table":"styles__sample-table___1ARr_","update-buttons":"styles__update-buttons___9vi_H"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TagLabelConfiguration/styles.scss
// module id = 7641
// module chunks = 0